<template>
  <div>
    <Top></Top>
    <div class="main">
      <h2>
        定休日：
        <span>毎週日曜日</span>
      </h2>
      <p>チャットツール受付時間：9：30～18：30</p>
      <p>（日、祝日（中国）を除く）</p>
      <div class="calendar">
        <el-calendar v-model="value" data></el-calendar>
      </div>
      <h2>詳細</h2>
      <div class="border">
        <h3>
          2020-07-14
          なし
        </h3>
      </div>
    </div>
  </div>
</template>
<script>
import Top from "../../components/head/Top";

export default {
  data() {
    return {
      value: new Date()
    };
  },
  components: {
    Top
  },
  methods: {}
};
</script>
<style lang='scss' scoped>
.main {
  width: 1200px;
  margin: 50px auto;
  h2 {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 30px;
    span {
      color: #F3C622;
    }
  }
  p {
    font-size: 20px;
    line-height: 40px;
  }
  .calendar {
    margin: 50px 0 50px;
  }
  .border {
    border: 1PX solid #ccc;
    height: 70px;
    padding-left: 100px;
    line-height: 70px;
    h3 {
      font-size: 24px;
      color: #666;
    }
  }
  /deep/.el-calendar-table__row td:nth-last-child(1) {
    color: #F3C622;
  }
  /deep/ .is-selected {
    background: #F3C622;
    color: #fff !important;
  }
  /deep/ .el-calendar-day {
    &:hover {
      background: #F3C622;
      color: #fff;
    }
  }
}
</style>